Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.SocialContent extends Backbone.Model
  paramRoot: 'social_content'
  SENTIMENTS = [-20, 20, 0]
  @NOT_FOUND_TEXT = 'Content not found.'

  defaults:
    edit_tags: false

  interaction: ->
    return @get('data').interaction

  groupType: ->
    return @get('group_type')

  isNotFound: ->
    @get('data')?.text == Monitoring.Models.SocialContents.SocialContent.NOT_FOUND_TEXT

  subType: ->
    return @get('data').sub_type || @type()

  origin: ->
    return ''

  newSubType: ->
    @subType()

  privacy: ->
    if @subType() in ['direct-message', 'fb-message', 'email'] then 'private' else 'public'

  type: ->
    return @get('data').type

  numeric_id: ->
    return @get('data').id

  externalId: ->
    # should return the providers content id
    @numeric_id()

  cassandra_id: ->
    return @get('id')

  isTweet: ->
    @get('data').sub_type == 'tweet'

  isRetweet: ->
    @get('data').sub_type == 'retweet'

  isDrillDownMode: ->
    @get('isDrillDownMode')

  isQuote: ->
    @get('data').sub_type == 'quote'

  isEmail: ->
    @type() == 'email'

  isChat: ->
    @type() == 'chat'

  isWhatsapp: ->
    @type() == 'whatsapp'

  isWebchat: ->
    @type() == "webchat"

  isInstagramMessage: ->
    @subType() == 'ig-message' && @get('data').origin == 'instagram-message-api'

  isPrivateMessage: ->
    false

  hasUser: ->
    true

  quotedAvatar: ->
    if @get('data').quoted_status
      @get('data').quoted_status.user.profile_image_url
    else
      @get('data').twitter_quoted_status.actor.image

  quotedAuthor: ->
    if @get('data').quoted_status
      @get('data').quoted_status.user.name
    else
      @get('data').twitter_quoted_status.actor.displayName

  quotedText: ->
    if @get('data').quoted_status
      @get('data').quoted_status.text
    else
      @get('data').twitter_quoted_status.body

  quotedUserName: ->
    if @get('data').quoted_status
      @get('data').quoted_status.user.screen_name
    else
      @get('data').twitter_quoted_status.actor.preferredUsername

  initialize: (json) ->
    data = json.data
    evidences = json.evidences
    enrichedSocialMetrics = json.enriched_social_metrics || {}
    if typeof(data) == 'string'
      data = $.parseJSON(data)
    if typeof(evidences) == 'string'
      evidences = $.parseJSON(evidences)
    if typeof(enrichedSocialMetrics) == 'string'
      enrichedSocialMetrics = $.parseJSON(enrichedSocialMetrics)
    @set('data', data)
    @set('evidences', evidences)
    @set('enriched_social_metrics', enrichedSocialMetrics)

  enrichedSocialMetrics: ->
    metrics = @get('enriched_social_metrics')
    if @isTweet() || @isRetweet() || @isQuote()
      {
        retweets_count: { value: @safeMetric(metrics.retweets_count), icon_classes: 'fa fa-retweet' },
        quotes_count: { value: @safeMetric(metrics.quotes_count), icon_classes: 'fa fa-quote-right' },
        potential_impressions: { value: @safeMetric(metrics.potential_impressions), icon_classes: 'fa fa-bar-chart' },
        potential_reach: { value: @safeMetric(metrics.potential_reach), icon_classes: 'fa fa-globe' },
      }
    else
      {}

  safeMetric: (value) ->
    if _.isNumber(value) then value else '-'

  sortedEnrichedSocialMetricCodes: ->
    if @isTweet() || @isRetweet() || @isQuote()
      [
        'retweets_count',
        'quotes_count',
        'potential_impressions',
        # 'potential_reach'
      ]
    else
      []

  sentiment: ->
    if @getSentiment()
      value = @getSentiment().value
      if value <= -1
        return 'Negative'
      else if value >= 1
        return 'Positive'
      else if value == 0
        return 'Neutral'
      else return ''
    return ''

  _transformSentimentForArray: (sentiment) ->
    return '' unless sentiment
    value = sentiment.value
    if value < 0
      return -20
    else if value > 0
      return 20
    else if value == 0
      return 0
    else
      return ''

  sentimentValue: ->
    return if @getSentiment() then @getSentiment().value else 0

  getSentiment: (value = false) ->
    if @get('data')
      if value
        @get('data').sentiment?.value
      else
        @get('data').sentiment
    else
      undefined

  setSentiment: (value) ->
    sentiment = @getSentiment()
    sentiment ||= {}
    sentiment.value = value
    @get('data').sentiment = sentiment

  created_at: ->
    console.log('NOT IMPLEMENTED METHOD: created_at')

  created_at_ISO: ->
    date = @created_at()
    if date
      return new Date(date).format()
    else
      return ''

  avatar: ->
    return window.image_path('default-avatar.gif')

  userLink: ->
    false

  link: ->
    false

  link_media_url: (link) ->
    "/snapshot/preview?url=#{link}"

  tags: (codes_only = true) ->
    # TODO: check if the optional param is working
    if codes_only
      @get('tags') || []
    else
      _.filter(@possibleTags(), (tag) =>
        _.contains(@get('tags'), tag.code))

  possibleTags: ->
    tags = @get('possibleTags') or []
    _.sortBy(tags, (t) -> t.description.toLowerCase())

  addTags: (codes) ->
    @set('tags', _.uniq(@get('tags').concat(codes)))

  mainTags: ->
    return @possibleTags().filter (tag) =>
       @isMainTag(tag)

  arrayHasTag: (array, tag) ->
    tag = tag || {}
    description = tag.description || ''
    code = tag.code || ''
    _.intersection(array, [tag, tag.description, tag.code]).length > 0

  hasTag: (tag) ->
    @arrayHasTag(@tags(), tag)

  isMainTag: (tag) ->
    @hasTag(tag) or @isHotTag(tag) or @isSuggestedTag(tag)

  isHotTag: (tag) ->
    @canEditTags() and tag.hot_tag

  isSuggestedTag: (tag) ->
    @arrayHasTag(@suggestedTags(), tag)

  negativeTags: ->
    return @possibleTags().filter (tag) =>
      tag.implies_rejection == true && !@isMainTag(tag)

  neutralTags: ->
    return @possibleTags().filter (tag) =>
      tag.implies_rejection == false && !@isMainTag(tag)

  suggestedTags: ->
    return @get('suggested_tags') || []

  unappliedTags: ->
    @neutralTags().concat(@negativeTags()) # does not include suggested tags

  allTagsActAsHot: ->
    false

  isReviewMode: ->
    return @get('review_mode')

  canEditTags: ->
    return (@get('edit_tags') || @isReviewMode())

  labels: ->
    return @get('labels')

  status: ->
    return @get('status')

  status_class: ->
    if @status() == 'APPROVED'
      return 'approved'
    else if @status() == 'REJECTED'
      return 'rejected'
    else if @status() == 'UNKNOWN'
      return 'pending'
    else
      return ''

  id: ->
    return @get('id')

  lastModerator: ->
    return @get('last_moderator')

  legacyId: ->
    return @get('legacy_id')

  getTopicsName: ->
    return _.pluck(@get('topics'), 'name')

  topicAllowsCustomer: ->
    return _.some(@get('topics'), (topic) -> topic.customer_enabled)

  addAnchorsToLinks: (content) ->
    # the original regex from mati was
    # /(?:<em .*?>)?(?:(https?:\/\/[\w\.\-\d\?&=\/]*)(?:<em .*?>(.*?)<\/em>)?)(?:<\/em>)?([\%\w\.\-\d\?&=\/]*)?/g
    # the new regex source was stackoverflow -- it detects any http* url
    regex = /https?:\/\/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b[-a-zA-Z0-9@:%_\+.~#?&\/=]*/
    # warning: the replacement cant have ' !! you should use " !! thats because it breaks the ContentEnhancer
    replacement = "<a target=\"_blank\" href=\"%{match}\">#{I18n.t('monitoring.dashboard.social_content.open_link')}</a>"
    contentBeautifier = new Monitoring.Models.ContentBeautifier(content)
    contentBeautifier.replace(regex, replacement)

  getSortedEvidencesBy: (field) ->
    return _.sortBy(_.groupBy(_.filter((@get('evidences') || []), (evidence) -> evidence.field == field), 'start'), (val, key, evidence) ->  key * -1)

  content: ->
    return ''

  enhancedContent: ->
    @getContentEnhancer().getContent()

  getContentEnhancer: (text=null) =>
    return new Monitoring.Models.ContentEnhancer(this, text)

  name: ->
    @get('data').interaction?.author?.name

  isFacebook: ->
    return false

  hasContentUrl: -> @contentUrl() if @contentUrl

  getMedias: ->
    []

  isPublished: ->
    false

  isHidden: ->
    false

  canPlayVideoType: (type) ->  #This method is used because Mozilla Firefox has trouble playing mp4 videos, and twitter uses this format for gifs
    !!document.createElement('video').canPlayType(type)

  hasShares: ->
    false

  hasContext: ->
    try
      if @getRootParentId() then true else false
    catch
      false

  hasRelated: ->
    true

  getRootParentId: ->
    throw new Error("contents of subtype " + @subType() + " do not have a root parent")

  getImmediateParentId: ->
    throw new Error("contents of subtype " + @subType() + " do not have an immediate parent")

  isResponseFromClient: ->
    (@get('is_response_from_client') == true) || (@get('is_response_from_client') == 'true')

  isStartingInteraction: ->
    @get('interaction_type') == 'StartingInteraction'

  isBrandContent: ->
    is_brand_content = @get('is_brand_content')
    return is_brand_content if is_brand_content
    content = @get('data')['content']
    page_owner_generated = content != undefined && content['page_owner_generated'] == 'true'
    page_owner_generated || @isResponseFromClient()

  socialNetworkName: ->
    type = @type()
    return 'facebook' if /(FBPost|FBComment|FBMessage)/.test(type)
    return 'instagram' if /instagram/.test(type)
    return 'disqus' if /(disqus|TMZ|TooFab)/i.test(type)
    return 'livefyre' if /(Livefyre)/i.test(type)
    type

  hasProfile: ->
    true

  inResponseTo: ->
    @get('data').content['in_response_to']

  to_addresses: ->
    return @get('data').to_addresses if @get('data').to_addresses

  hasCc: ->
    return @get('data').cc_addresses && @get('data').cc_addresses.length > 0

  hasBcc: ->
    return @get('data').bcc_addresses && @get('data').bcc_addresses.length > 0

  cc_addresses: ->
    @get('data').cc_addresses.join(", ")

  bcc_addresses: ->
    @get('data').bcc_addresses.join(", ")

  isListeningOnly: ->
    false

  uniqueId: ->
    UniqueId.get(@externalId())

  childrenSocialContents: (allTags) ->
    _.map @get('children'), (childSocialContentObject) =>
      @_createChildSocialContent(childSocialContentObject, allTags)

  _createChildSocialContent: (childSocialContentObject, allTags) ->
    analysisUnitFactory = new Monitoring.Models.SocialContents.AnalysisUnitFactory()
    newChildSocialContent = analysisUnitFactory.create(childSocialContentObject, allTags)
    newChildSocialContent.set(
      isChild: true
      parentInteraction: @
    )

class Monitoring.Collections.SocialContentsCollection extends Backbone.Collection
  model: Monitoring.Models.SocialContents.SocialContent
  url: '/social_contents'
